//@ts-ignore
const G2 = window.G2Plot

export class ReadCountChart {
  static chartInstance: any

  static render(el: HTMLDivElement, data: any) {
    if (this.chartInstance) {
      this.chartInstance.destroy()
    }

    const scaleXProp = 'dt'
    const scaleYProp = 'read_count'

    this.chartInstance = new G2.Line(el, {
      data,
      xField: scaleXProp,
      yField: scaleYProp,
      meta: {
        [scaleXProp]: {
          type: 'time',
          mask: 'MM-DD'
        },
        [scaleYProp]: {
          min: 0,
          alias: '图书数',
          formatter: val => {
            return `${val.toFixed(0)}`
          }
        }
      },
      smooth: true
    })

    this.chartInstance.render()
  }
}
